import React, { useCallback, useEffect, useState } from "react"
import { Table } from "reactstrap";
import DatePicker from "web/components/DatePicker";
import { InnerHeader, SelectWrapper, SelectWrapperMulti, SearchWrapper } from "../reportsStyled";
import * as moment from 'moment';
import MultiSelectLocation from "./MultiSelectLocation";
import { AiOutlineSearch } from "react-icons/ai";
import { Pagination } from "@material-ui/lab";
import { ptPlusOrderReportsApi } from "redux/actions/adminPtPlus";
import { ptPlusBuyBackMainLocationList, ptPlusBuyBackSubLocationList } from "redux/actions/adminPTPlusBuyBackFee"
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AlertModal from "web/components/AlertModal";
import { hideAppLoader } from 'redux/actions/app';
import debounce from "lodash.debounce";
import { orderHeaderArr, pickupOrderHeaderArr } from "../Constants"
import { sortListOfObjects } from 'helpers'
import { stateConvert } from "web/components/utils/stateAbbreviation";

const OrderReport = ({ TabPanel, tabValue, downloadPTPlusReportCSV, isDownloadingPtPlusOrderReportCSV }) => {
  const token = localStorage.getItem('token')
  const dispatch = useDispatch()
  const history = useHistory()

  const [finalData, setFinalData] = useState([]);
  const [customersList, setCustomersList] = useState()
  const [selectedCustomersList, setSelectedCustomersList] = useState();
  const [customersLocationsList, setCustomersLocationsList] = useState()
  const [selectedCustomersLocationsList, setSelectedCustomersLocationsList] = useState();
  const [tableSearch, setTableSearch] = useState('')
  const [tableHeader, setTableHeader] = useState(tabValue === 1 ? pickupOrderHeaderArr : orderHeaderArr)
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  let toDatePTOrderReport = new Date();
  toDatePTOrderReport.setMonth(toDatePTOrderReport.getMonth() + 2)
  let fromDatePTOrderReport = new Date();
  fromDatePTOrderReport.setMonth(fromDatePTOrderReport.getMonth() - 6)

  const [startDateValue, setStartDateValue] = useState(moment(fromDatePTOrderReport).format("MM/DD/YYYY"))
  const [endDateValue, setEndDateValue] = useState(moment(toDatePTOrderReport).format("MM/DD/YYYY"))
  const [userFilterState, setUserFilterState] = useState({
    fromDate: moment(fromDatePTOrderReport).format("MM/DD/YYYY"),
    toDate: moment(toDatePTOrderReport).format("MM/DD/YYYY"),
    company: "ALL"
  })

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchCustomerList()
  }, []);

  useEffect(() => {
    setFinalData([])
    setPage(1)
    fetchOrderReportList(1)
    if (tabValue === 1) setTableHeader(pickupOrderHeaderArr)
    else setTableHeader(orderHeaderArr)
  }, [tabValue])

  const fetchCustomerList = async () => {
    let response = await dispatch(ptPlusBuyBackMainLocationList(token));
    if (response && response?.success) {
      if (response.data?.mainLocations?.length) {
        const arr = response.data.mainLocations?.map((val) => ({
          label: val.locationName?.trim(),
          value: val.locationId,
        }));
        const sortedLocationOptions = sortListOfObjects("string", arr, "asc", "label") // sort alphabetically
        setCustomersList(sortedLocationOptions);
      }
    } else {
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!')
        setModalLink("");
        toggleModal();
      }
    }
  };

  const fetchCustomerLocationsList = async (locationIds) => {
    try {
      const locationIdsArray = Array.isArray(locationIds) ? locationIds : [locationIds].filter(Boolean);
      const data = { locationIds: locationIdsArray };

      let response = await dispatch(ptPlusBuyBackSubLocationList(data));

      if (response && response?.success && response?.data && response?.data?.locDetList) {
        const arr = response?.data?.locDetList?.map(location => ({
          label: `${location.locationName} - ${location?.city}, ${location?.state}`,
          value: location.locationId,
          name: location.locationName?.trim(), // for sorting
        }));
        const sortedLocationOptions = sortListOfObjects("string", arr, "asc", "name") // sort alphabetically
        setCustomersLocationsList(sortedLocationOptions);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const handleErrorResponse = (response) => {
    if (response.statusCode === 401) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      setPageCount(0)
      setModalContent(response?.data?.error?.message || response.message || response || 'Something went wrong, please try again!')
      setModalLink("");
      toggleModal();
    }
  };

  const fetchOrderReportList = async (selectPage, search, getFromDate, getToDate, tabVal) => {
    const locationsIds = selectedCustomersList
      ? (selectedCustomersLocationsList || customersLocationsList).map(loc => loc.value)
      : ['ALL'];

    let fromDateVal = moment(getFromDate || userFilterState.fromDate, 'MM/DD/YYYY');
    let toDateVal = moment(getToDate || userFilterState.toDate, 'MM/DD/YYYY');

    if (!fromDateVal.isValid() || !toDateVal.isValid() || toDateVal.isBefore(fromDateVal)) {
      setModalContent('Please select a valid date.');
      setModalLink("");
      setModal(!modal);
      return;
    }

    let data = {
      size: 10,
      number: selectPage ? (selectPage - 1) : 0,
      sort: "DESC",
      companyId: locationsIds.length !== 0 ? locationsIds : [userFilterState.company],
      searchBy: search || tableSearch || "",
      startDate: fromDateVal.isValid() ? fromDateVal.format('YYYY-MM-DD') : '',
      endDate: toDateVal.isValid() ? toDateVal.format('YYYY-MM-DD') : ''
    }
    let url
    let selectedCurrentTab = tabVal ? tabVal : tabValue
    if (selectedCurrentTab === 0) url = 'ptms/admin/order_report'
    else if (selectedCurrentTab === 1) url = 'ptms/admin/pickup/get_order_list'
    let response = await dispatch(ptPlusOrderReportsApi(url, data))

    if (response && response?.success) {
      dispatch(hideAppLoader());
      if ((response?.data?.list || response?.data?.pickupOrderList) && (response?.data?.list?.length > 0 || response?.data?.pickupOrderList?.length > 0)) {
        setFinalData(response?.data?.list || response?.data?.pickupOrderList)
        setPageCount(response?.data?.totalPages)
      } else {
        setFinalData([])
        setPageCount(0)
      }
    } else {
      dispatch(hideAppLoader());
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!')
        setModalLink("");
        toggleModal();
      }
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    setFinalData([])
    fetchOrderReportList(value, tableSearch)
  };

  const handleDebounceOrderReportSearch = useCallback(
    debounce((selectPage, searchtext, getFromDate, getToDate, tabValue) => fetchOrderReportList(selectPage, searchtext, getFromDate, getToDate, tabValue), 500),
    []
  );

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPage(1)
    let searchtext = e.target.value
    setFinalData([])
    handleDebounceOrderReportSearch(0, searchtext, userFilterState.fromDate, userFilterState.toDate, tabValue);
  }

  return (
    <TabPanel value={tabValue} index={tabValue}>
      <InnerHeader>
        <SelectWrapperMulti>
          <label className="font-weight-bold">Start Date:</label>
          <DatePicker
            name="fromDatePTOrderReport"
            maxDOBirth={userFilterState.toDate}
            value={userFilterState.fromDate}
            inputValue={startDateValue}
            callBackFun={(date, value) => {
              setStartDateValue(value)
              if (moment(date, moment.ISO_8601, true).isValid()) {
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["fromDate"]: moment(date).format("MM/DD/YYYY"),
                }));
              } else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["fromDate"]: null,
                }));
              }
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapperMulti>
          <label className="font-weight-bold">End Date:</label>
          <DatePicker
            name="toDatePTOrderReport"
            minDOBirth={userFilterState.fromDate}
            value={userFilterState.toDate}
            inputValue={endDateValue}
            callBackFun={(date, value) => {
              setEndDateValue(value)
              if (moment(date, moment.ISO_8601, true).isValid()) {
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["toDate"]: moment(date).format("MM/DD/YYYY"),
                }));
              } else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["toDate"]: null,
                }));
              }
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapperMulti>
          <label className="font-weight-bold">Customer Name:</label>
          <MultiSelectLocation
            name="customer"
            placeholder='Select'
            data={customersList}
            defaultValueArr={selectedCustomersList}
            setMultiSelectVal={(multiSelectVal) => {
              if (multiSelectVal) {
                setSelectedCustomersList(multiSelectVal)
                fetchCustomerLocationsList(multiSelectVal?.map((customer) => customer.value))
              } else {
                setSelectedCustomersList()
                setCustomersLocationsList()
                setSelectedCustomersLocationsList()
              }
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapperMulti>
          <label className="font-weight-bold">Customer Locations Name:</label>
          <MultiSelectLocation
            name="customerLocations"
            placeholder='Select'
            data={customersLocationsList}
            defaultValueArr={selectedCustomersLocationsList}
            setMultiSelectVal={(multiSelectVal) => {
              if (multiSelectVal) setSelectedCustomersLocationsList(multiSelectVal)
              else setSelectedCustomersLocationsList()
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapper>
          <label style={{ marginTop: "22px", backgroundColor: "transparent" }}></label>
          <button
            onClick={() => {
              setPage(1)
              setFinalData([])
              fetchOrderReportList(1, tableSearch);
            }}
          >
            Submit
          </button>
        </SelectWrapper>

        <div className="d-flex flex-grow-1 justify-content-end" style={{ marginTop: "33px" }}>
          <SearchWrapper>
            <input
              type="text"
              placeholder='Search'
              value={tableSearch}
              onChange={(e) => {
                handleSearchChange(e)
              }}
            />
            <AiOutlineSearch />
          </SearchWrapper>
          <button
            disabled={isDownloadingPtPlusOrderReportCSV}
            onClick={() => {
              const locationsIds = selectedCustomersList
                ? (selectedCustomersLocationsList || customersLocationsList).map(loc => loc.value)
                : ['ALL'];
              downloadPTPlusReportCSV(locationsIds, tabValue === 1 ? 'pickupOrder' : 'delOrder', tableSearch, userFilterState, dispatch)
            }}
            style={{ background: isDownloadingPtPlusOrderReportCSV ? '#b2afac' : 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', minHeight: "46px", color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }}>
            {isDownloadingPtPlusOrderReportCSV ? "Exporting..." : "Export"}
          </button>
        </div>
      </InnerHeader>



      <Table responsive>
        <thead>
          <tr>
            {tableHeader.map((items, index) => (
              <th key={index}>
                {items.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {finalData && finalData.length > 0 ? (
            finalData.map((items, index) => (
              <tr key={index} className='user-list-table-styles'>
                <td>{items?.orderRefNumber || "NA"}</td>
                <td>{items?.orderId || "NA"}</td>
                <td>{tabValue === 1 ? (items?.pickupLocationInfo?.locationName || 'NA') : (items?.companyName || "NA")}</td>
                <td>{items?.poNumber || "NA"}</td>
                <td>{tabValue === 1 ? (items?.requestedPickupDate || "NA") : (items?.requestedDate || "NA")}</td>
                <td>{tabValue === 1 ? (items?.actualPickupDate || "NA") : (items?.actualDeliveryDate || "NA")}</td>
                <td>{items?.orderStatus ? (items?.orderStatus === 'CANCELLED' ? 'CANCELED' : items?.orderStatus) : "NA"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={tableHeader?.length} style={{ position: 'relative', textAlign: 'center' }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {pageCount && finalData && finalData?.length !== 0 ? <Pagination count={pageCount}
        page={page}
        onChange={handlePageChange} /> : ""}
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={modalTitle}
        content={modalContent}
        link={modalLink}
        // alertType={alertType}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={(val) => {
          if (val === "success") history.push('/ptplus-reports')
          else toggleModal()
        }}
      />
    </TabPanel>
  )
}

export default OrderReport